export class Mouse {
    static clickedLeft = (e) => e.button === 0;
}
